import React from "react";
import {
	ChatLoader,
	ChatMessagesWrapper,
	SendMessage,
} from "@features/chat/mobile";

export default function ChatContent() {
	return (
		<>
			<div className="chat__box">
				<ChatLoader />
				<ChatMessagesWrapper />
				<SendMessage />
			</div>
		</>
	);
}
